<template>
  <div>
    <div class="p-5 w-full flex flex-col">
      <div class="flex flex-row">
        <div class="w-1/3 flex flex-row items-center">
          <p class="font-semibold text-3xl">
            Facility Checklist Performance Dashboard
          </p>
        </div>
        <div class="w-2/3 flex flex-row items-center justify-end">
          <date-picker
            v-model="dateStart"
            type="date"
            value-type="format"
            format="DD-MMM-YYYY"
            placeholder="Start date"
          />
          <span class="mx-3"> - </span>
          <date-picker
            v-model="dateEnd"
            type="date"
            value-type="format"
            format="DD-MMM-YYYY"
            placeholder="End date"
          />
          <vs-button
            ref="fetchButton"
            type="filled"
            icon="visibility"
            color="secondary"
            class="mx-3 rounded-xl vs-con-loading__container"
          />
          <div class="mx-3 divider" />
          <vs-button
            ref="downloadButton"
            type="filled"
            color="secondary"
            class="mx-3 w-32 font-semibold vs-con-loading__container"
          >
            Export PDF
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/datePicker'

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      dateStart: null,
      dateEnd: null
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.datepicker {
  width: 145px !important;
}

/deep/.mx-input-wrapper {
  background-color: white !important;
}

.divider {
  @apply h-10;

  border-left: solid 1px #DEDEDE;
}
</style>
